import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { AuthFrame, Button, Hint, Stack } from '@src/components';

export function SupportAccessPage() {
  const { i18n } = useTranslation();
  const ru = i18n.language.startsWith('ru');
  const token = useLocation().hash.slice(1);
  const [busy, setBusy] = useState(false);
  const pending = useRef(false);
  const [failed, setFailed] = useState(false);
  const valid = /^[a-f0-9]{64}$/.test(token);
  async function signIn() {
    if (pending.current || !valid) return;
    pending.current = true;
    setBusy(true);
    setFailed(false);
    try {
      const response = await fetch('/api/login/support-access', {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ token }),
      });
      if (!response.ok) throw new Error('Unavailable');
      window.location.replace('/account');
    } catch { setFailed(true); pending.current = false; setBusy(false); }
  }
  return <AuthFrame title={ru ? 'Восстановление доступа' : 'Restore access'} testId="support-access-page">
    <Stack gap={3}>
      <p>{ru ? 'Нажмите «Войти», чтобы восстановить доступ к своему профилю.' : 'Click “Sign in” to restore access to your profile.'}</p>
      <p>{ru ? 'После входа привяжите и подтвердите email в настройках профиля. Там же можно установить пароль и создать и сохранить коды восстановления.' : 'After signing in, link and verify your email in your profile settings. You can also set a password and generate and save recovery codes there.'}</p>
      {(!valid || failed) && <Hint tone="error">{ru ? 'Не удалось войти. Ссылка могла истечь, быть использована или заменена. Обратитесь в поддержку за новой ссылкой.' : 'Could not sign in. The link may have expired, been used or replaced. Contact support for a new link.'}</Hint>}
      <Button disabled={!valid || busy} loading={busy} onClick={() => void signIn()}>{ru ? 'Войти' : 'Sign in'}</Button>
    </Stack>
  </AuthFrame>;
}
